module.exports = __webpack_public_path__ + "static/img/2.7f84ad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cooperate/2.png
// module id = g1hU
// module chunks = 1